import {svgIconWrapper} from '../svg-icon-wrapper';

import ConnectionRegular from './connection-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ConnectionRegular {...props} />;
}
SvgComponent.iconName = 'connectionRegular';

export const ConnectionRegularIcon = svgIconWrapper(SvgComponent);
